import { BrowserModule } from "@angular/platform-browser";
import { NgModule, LOCALE_ID } from "@angular/core";
import { ArticlePropertiesComponent } from './components/site-management/article-properties/article-properties.component';



import { AppRoutingModule } from "./modules/app-routing.module";
import { AppComponent } from "./app.component";
import { StoreModule } from "@ngrx/store";
import { reducers, metaReducers } from "./reducers";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { environment } from "../environments/environment";
import { EffectsModule } from "@ngrx/effects";
import { MatButtonModule } from '@angular/material/button';
import { ConfirmDialogComponent } from './components/ConfirmDialog/ConfirmDialog.component';


// Effects

import { NewsEffects } from "./effects/news.effects";
import { SearchEffects } from "./effects/search.effects";
import { ErrorEffects } from "./effects/error.effects";
import { FactorsEffects } from "./effects/factors.effects";
import { MiscEffects } from "./effects/misc.effects";
import { UserFeedbackEffects } from "./effects/user-feedback.effects";
import { RouterEffects } from "./effects/router.effects";
import { MappingEffects } from "./effects/mapping.effects";
import { MatMenuModule } from '@angular/material/menu';

// Guards

import { CanDeactivateGuard } from "./guards/can-deactivate.guard";

// Components
import { TranslationServiceToolsEditorComponent } from './components/translation-service-tools/translation-service-tools-editor/translation-service-tools-editor.component';
import { NewsComponent } from "./components/news/news.component";
import { NewsEditorComponent } from "./components/news-editor/news-editor.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MaterialComponentsModule } from "./modules/material-components.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { newsReducer } from "./reducers/news.reducer";
import { NavComponent } from "./components/nav/nav.component";
import { EditorComponent } from "./components/editor/editor.component";

import { TagTreeComponent } from "./components/tag-tree/tag-tree.component";
import { MatIconModule } from '@angular/material/icon';
import { LeafletModule } from "@asymmetrik/ngx-leaflet";
import { LeafletDrawModule } from "@asymmetrik/ngx-leaflet-draw";
import { NgChartsModule } from "ng2-charts";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { ToastrModule } from "ngx-toastr";
import { SearchComponent } from "./components/search/search.component";
import {
  DateAdapter,
  DateAdapter as dateAdapterMaterial,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE as dateLocalMaterial,
} from "@angular/material/core";
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
} from "@angular/material-moment-adapter";
import { NgxSpinnerModule } from "ngx-spinner";
import { MapComponent } from "./components/graphs/map/map.component";
import { EditorMapComponent } from "./components/news-editor/editor-map/editor-map.component";
import { DeleteDialogComponent } from "./components/misc-components/delete-dialog/delete-dialog.component";
import { SourceMappingComponent } from "./components/source-management/source-mapping/source-mapping.component";
import { SourceManagementComponent } from "./components/source-management/source-management.component";
import { FileUploadComponent } from "./components/file-upload/file-upload.component";
import { LogViewerDialogComponent } from './components/misc-components/Loger-Viewer/Loger-Viewer.component';
import { ResizableModule } from "angular-resizable-element";
import { UserEditorComponent } from "./components/userComponents/user-editor/user-editor.component";
import { UserManagerComponent } from "./components/userComponents/user-manager/user-manager.component";
import { RoleManagerComponent } from "./components/roleComponents/role-manager/role-manager.component";
import { RoleEditorComponent } from "./components/roleComponents/role-editor/role-editor.component";
import { MatCardModule } from '@angular/material/card';
import { RoleColorPickerComponent } from "./components/Colorpicker/RoleColorPicker.component";
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { LoginComponent } from "./components/login/login.component";

import { CommonModule } from "@angular/common";
import { ContentLoaderModule } from "@ngneat/content-loader";
import { RangeSliderComponent } from "./components/range-slider/range-slider.component";
import { registerLocaleData } from "@angular/common";
import localede from "@angular/common/locales/de";
import { StoreRouterConnectingModule, routerReducer } from "@ngrx/router-store";
import { CustomSerializer } from "./CustomRouterSerializer";
import { BhStatsComponent } from "./components/bh-stats/bh-stats.component";
import { TagCloudComponent } from "angular-tag-cloud-module";
import { AboutDialogComponent } from "./components/AboutthisApp/about-dialog.component";
import { EditorMapModalWrapperComponent } from "./components/news-editor/editor-map-modal-wrapper/editor-map-modal-wrapper.component";
import { PermissionErrorComponent } from "./components/permission-error/permission-error.component";
import {
  ReIndexDialogComponent,
  SiteManagementComponent,
} from "./components/site-management/site-management.component";
import { TagsComponent } from "./components/tags/tags.component";
import { MatDialogModule } from '@angular/material/dialog';
import {
  TagEditDialogComponent,
  TagEditTreeComponent,
} from "./components/tags/tag-edit-tree/tag-edit-tree.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from "@angular/material/input";
import {
  HistoryDetailsComponent,
  LoggingComponent,
} from "./components/site-management/logging/logging.component";
import { Chart, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { ColorPickerModule } from "@iplab/ngx-color-picker";
import { AuthInterceptor } from "./interceptors/auth.interceptor";
import { searchRequest } from "./actions/news.actions";
import { UpdateAndSaveDialogComponent } from './components/misc-components/updateandSave-dialog/updateandSave-dialog.component';
registerLocaleData(localede);
Chart.register(...registerables, ChartDataLabels);

@NgModule({
  declarations: [
    AppComponent,
    NewsComponent,
    NavComponent,
    EditorComponent,
    TagTreeComponent,
    DashboardComponent,
    SearchComponent,
    MapComponent,
    ArticlePropertiesComponent,
    UpdateAndSaveDialogComponent,
    DeleteDialogComponent,
    SourceMappingComponent,
    LogViewerDialogComponent,
    SourceManagementComponent,
    ConfirmDialogComponent,
    FileUploadComponent,
    UserEditorComponent,
    UserManagerComponent,
    LoginComponent,
    RangeSliderComponent,
    RoleManagerComponent,
    RoleEditorComponent,
    BhStatsComponent,
    NewsEditorComponent,
    EditorMapComponent,
    RoleColorPickerComponent,
    EditorMapModalWrapperComponent,
    PermissionErrorComponent,

    SiteManagementComponent,
    TagsComponent,
    TagEditTreeComponent,
    TagEditDialogComponent,
    HistoryDetailsComponent,
    ReIndexDialogComponent,
    DeleteDialogComponent,
    EditorMapModalWrapperComponent,
    LoggingComponent,
    TranslationServiceToolsEditorComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    LeafletModule,
    MatTabsModule,
    LeafletDrawModule,
    CKEditorModule,
    AboutDialogComponent,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    NgChartsModule,
    MatDialogModule,
    HttpClientModule,
    MatCardModule,
    MatDialogModule,
    NgxSpinnerModule,
    ResizableModule,
    ContentLoaderModule,
    MatButtonModule,
    MatIconModule,
    MatSnackBarModule,
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
    }),
    AppRoutingModule,
    StoreRouterConnectingModule.forRoot({
      serializer: CustomSerializer,
    }),
    StoreDevtoolsModule.instrument({ connectInZone: true }),
    EffectsModule.forRoot([
      NewsEffects,
      SearchEffects,
      ErrorEffects,
      FactorsEffects,
      MiscEffects,
      MappingEffects,
      UserFeedbackEffects,
      RouterEffects,
    ]),
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: "toast-bottom-right",
      preventDuplicates: true,
    }),
    MaterialComponentsModule,
    TagCloudComponent,
    MatFormFieldModule,
    MatInputModule,
    ColorPickerModule,
  ],
  providers: [
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    { provide: dateLocalMaterial, useValue: "en-GB" },
    { provide: LOCALE_ID, useValue: "de-DE" },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [dateLocalMaterial, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    CanDeactivateGuard,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}